import Icon from "@amzn/meridian/esm/components/icon";
import Link from "@amzn/meridian/esm/components/link";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import alertTokens from "@amzn/meridian-tokens/base/icon/alert";
import zoomSdk from "@zoom/appssdk";
import LogManager from "../../utils/LogManager";
import { THEME_COLOR } from "../constants";
import WaveformLayout from "./WaveformLayout";

const AimsNotAvailable = ({ aimsNotAvailableMessage }) => {
  const handleLearnMoreClick = async () => {
    try {
      await zoomSdk.openUrl({
        url: "https://w.amazon.com/bin/view/UnifiedCommunications/MeetingSummaries/AiMS",
      });
    } catch (error) {
      LogManager.error("Failed to open URL in Zoom:", error);
    }
  };

  return (
    <WaveformLayout icon={<Icon tokens={alertTokens} color="warning" />}>
      <Text type="h50" color="secondary">Inform attendees if needed</Text>
      <Row height="16px"/>
      <Text fontFamily="amazonEmber" type="b200" color="secondary">
        {aimsNotAvailableMessage}
      </Text>
      <Row height="16px"/>
      <Link onClick={handleLearnMoreClick} type="secondary">
        <Theme tokens={{ textColorPrimary: THEME_COLOR.TEAL_GREEN }}>
          <Text color="primary" type="b200" fontFamily="amazonEmber">
            <u>Learn more</u>
          </Text>
        </Theme>
      </Link>
    </WaveformLayout>
  );
};

export default AimsNotAvailable;
